<app-elevated-access-banner
  *ngIf="isElevatedAccess$ | async"
></app-elevated-access-banner>
<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-chat-view class="{{ code }}-theme" *ngIf="showChat"></app-chat-view>
